import type { FaireProductEntity } from "../../entity_types/product";

export const p_87gqucwdvu: FaireProductEntity = {
  token: "p_87gqucwdvu",
  type: "product",
  name: 'Jon & Vinny\'s "UNTITLED" Espresso, 12 oz',
  brandToken: "b_8r7b7k3ydp",
  brandName: "Jon & Vinny's",
  imageUrl:
    "https://cdn.faire.com/fastly/c69aff68ab93cc3b1aaa1ade6eac6c0512f395c6b7918fcb251e71d5ffa7f239.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b0d5897adc26479575a6685096ef79039f1d2afbdf53917236a2d36fe86e646a.jpeg",
  ],
  priceDollars: 12,
  description:
    "\n * Whole bean\n * 100% certified organic coffee\n * Roasted in Los Angeles by canyon coffee ",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:13.757Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
